import { Notifications as NotificationsIcon } from '@mui/icons-material';
import { Badge, ClickAwayListener, Grow, IconButton, Popper } from '@mui/material';
import type React from 'react';
import { useState } from 'react';
import { useNotifications } from '../contexts/NotificationContext';
import { useThemeMode } from '../contexts/ThemeContext';
import NotificationDropdown from './NotificationDropdown';

const NotificationBell: React.FC = () => {
  const { unreadCount } = useNotifications();
  const { themeMode } = useThemeMode();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div>
        <IconButton
          onClick={handleClick}
          sx={{
            color: themeMode === 'dark' ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.6)',
            '&:hover': {
              color: themeMode === 'dark' ? '#fff' : '#1a1a2e',
              backgroundColor:
                themeMode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
            },
          }}
        >
          <Badge
            badgeContent={unreadCount}
            color="error"
            max={99}
            sx={{
              '& .MuiBadge-badge': {
                fontSize: '0.65rem',
                fontWeight: 700,
                minWidth: 18,
                height: 18,
                padding: '0 4px',
              },
            }}
          >
            <NotificationsIcon />
          </Badge>
        </IconButton>

        <Popper
          open={open}
          anchorEl={anchorEl}
          placement="bottom-end"
          transition
          style={{ zIndex: 1300 }}
        >
          {({ TransitionProps }) => (
            <Grow {...TransitionProps} style={{ transformOrigin: 'right top' }}>
              <div>
                <NotificationDropdown onClose={handleClose} />
              </div>
            </Grow>
          )}
        </Popper>
      </div>
    </ClickAwayListener>
  );
};

export default NotificationBell;
